import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Chip } from 'Components';

//Hooks
import { NotificationManager } from "Components/Notifications";
import { setContactId } from '../../../../core/hooks';
import {convertToKPH, convertToMI, convertToMIRound, OrderData} from 'Core/data/Helpers';


//Components
import { NotificationContainer } from "Components/Notifications";
import { Grid } from '@mui/material';
import {
    Modal,
    Form,
    Input,
    TextArea,
    Button,
    Select as SelectInterval,
    InputNumeric,
    FileUpload,
    SelectMenu,
    IconButton,
    DatePicker,
    Pill,
    Tooltip,
} from '@gpstrackit/gtc-react-controls';

import Select from 'Components/Select';

//Actions
import {
    uploadAttachment,
    catalogLoad,
} from 'Redux/actions';
import {
    reset,
    maintenanceMCSGetMaintenanceService,
    maintenanceMCSCreateEditMaintenanceService,
    maintenanceMCSCSearchMaintenanceServiceItems,
    maintenanceMCSCCreateMaintenanceServiceItem
} from './redux/slice';

//Styles
import './styles.scss'

const CreateEditMaintenanceService = (props) => {
    const { refresh } = props;
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();
    const updateFormRef = Form.useForm();
    const intervalTypeFormRef = Form.useForm();
    const formRef = Form.useForm();

    const INTERVAL_TYPES = [
        { id: "Miles", name: messages['miles'] },
        { id: "Days", name: messages['days'] },
        { id: "Hours", name: messages['engineHours'] }
    ];

    const ALERT_TYPES = [
        { id: "Reminder", name: messages['reminder'] },
        { id: "DueNow", name: messages['dueNow'] },
        { id: "PastDue", name: messages['pastDue'] }
    ];

    const {
        createAlertSubscriberResponse,
        updateMaintenanceServiceResult,
        loadingCreateAlertSubscriber,
        service,
        loading,
        error,
        open,
        id,
        newServiceItemResult,
        serviceItems
    } = useSelector(state => state.maintenanceCreateEditMaintenanceServiceRedux);

    const {
        maintenanceServiceUnit
    } = useSelector(state => state.maintenanceCompleteMaintenanceServiceRedux);

    const {
        uploadedAttachment,
        loadingUploadFile,
    } = useSelector(state => state.commomRedux);
    const contactsReq = useSelector(state => state.catalogsRedux.contacts);
    const loadingContacts = useSelector(state => state.catalogsRedux.loadingContacts);
    const { user } = useSelector((state) => state.securityRedux);

    const [formData, setFormData] = useState({ intervalTypes: [], alerts: [], attachments: [] });
    const [intervalTypes, setIntervalTypes] = useState([...INTERVAL_TYPES]);
    const [intervalType, setIntervalType] = useState(null);
    const [interval, setInterval] = useState(null);
    const [reminder, setReminder] = useState(null);
    const [pastDue, setPastDue] = useState(null);
    const [intervalNew, setIntervalNew] = useState(null);
    const [reminderNew, setReminderNew] = useState(null);
    const [pastDueNew, setPastDueNew] = useState(null);
    const [errors, setErrors] = useState([]);

    const [serviceItemsValidation, setServiceItemsValidation] = useState(false);
    const [serviceItemSelected, setServiceItemSelected] = useState([]);
    const [checkReschedule, setCheckReschedule] = useState(false);
    const [optionsSelect, setOptionsSelect] = useState([]);

    //Lists
    const [contacts, setContacts] = useState([]);

    const handleSuccess = useCallback(() => {
        NotificationManager.success(
            messages['success'],
            messages['updateService_success'],
            3000,
            null,
            null,
            'success'
        );
        if (refresh) refresh();
        handleClose();
    })

    const correctCreation = (message) => {
        NotificationManager.success(
            message,
            messages['success'],
            3000,
            null,
            null,
            'success',
        );
    };
    
    useEffect(() => {
        if (newServiceItemResult?.id) {
            addNewServiceItemToSelect(newServiceItemResult);
            onChangeSelectedItems(newServiceItemResult)
            correctCreation(messages['completeMaintenanceService_service_item_success']);
            dispatch(reset({ newServiceItemResult: null }))
        }
    }, [newServiceItemResult])

    useEffect(() => {
        if (maintenanceServiceUnit?.service && serviceItems?.length > 0) {
            setOptionsSelect(OrderData(serviceItems, 'name'));
        }
    }, [maintenanceServiceUnit?.id]);

    useEffect(() => {
        if (serviceItems && Array.isArray(serviceItems) && serviceItems?.length > 0) {
            setOptionsSelect(OrderData(serviceItems, 'name'));
        }
    }, [serviceItems])

    useEffect(() => {
        dispatch(catalogLoad(["contacts"]));
        dispatch(maintenanceMCSCSearchMaintenanceServiceItems({}))
    }, []);

    useEffect(() => {
        if (contactsReq && contactsReq.length) {
            const newContacts = setContactId(contactsReq);
            setContacts(OrderData(newContacts, 'title'));
        }
    }, [contactsReq]);

    useEffect(() => {
        if (service) setData(service);
    }, [service]);

    useEffect(() => {
        if (id) dispatch(maintenanceMCSGetMaintenanceService({ id: id }));
    }, [id]);

    useEffect(() => {
        if (open && createAlertSubscriberResponse) {
            handleSuccess();
            dispatch(reset({ createAlertSubscriberResponse: null }));
        }
    }, [createAlertSubscriberResponse]);

    useEffect(() => {
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }))
        }
    }, [error])

    useEffect(() => {
        setIntervalTypes([...INTERVAL_TYPES])
        if(user.isKph){
            setIntervalTypes(INTERVAL_TYPES.map((item) => {
                if (item.id === "Miles"){
                    item.name = messages['kilometers'];
                }
                return item;
            }));
        }
    }, [locale, user])

    useEffect(() => {
        if (updateMaintenanceServiceResult && updateMaintenanceServiceResult.id) {
            handleSuccess();
            dispatch(reset());
        }
    }, [updateMaintenanceServiceResult]);

    const setData = (service) => {
        let newFormData = { intervalTypes: [], alerts: [] };
        if (service) {
            newFormData = { ...newFormData, ...service };
            let newIntervalTypesList = [];

            if (service.days) {
                newFormData.intervalTypes.push({
                    intervalType: { id: "Days", name: messages['days'] },
                    interval: { id: service.days, name: `${service.days} ${messages['days']}` },
                    reminder: { id: service.daysBefore, name: `${service.daysBefore} ${messages['days']}` },
                    pastDue: { id: service.daysAfter, name: `${service.daysAfter} ${messages['days']}` }
                });
            } else {
                newIntervalTypesList.push({ id: "Days", name: messages['days'] });
            }

            if (service.miles) {
                newFormData.intervalTypes.push({
                    intervalType: { id: "Miles", name: user.isKph ? messages['kilometers'] : messages['miles'] },
                    interval: { id: service.miles, name: `${user.isKph ? convertToKPH(service.miles) : service.miles} ${user.isKph ? messages['kilometers'] : messages['miles']}` },
                    reminder: { id: service.milesBefore, name: `${user.isKph ? convertToKPH(service.milesBefore) : service.milesBefore} ${user.isKph ? messages['kilometers'] : messages['miles']}` },
                    pastDue: { id: service.milesAfter, name: `${user.isKph ? convertToKPH(service.milesAfter) : service.milesAfter} ${user.isKph ? messages['kilometers'] : messages['miles']}` }
                });
            } else {
                newIntervalTypesList.push({ id: "Miles", name: user.isKph ? messages['kilometers'] : messages['miles'] });
            }

            if (service.engineHours) {
                newFormData.intervalTypes.push({
                    intervalType: { id: "Hours", name: messages['engineHours'] },
                    interval: { id: service.engineHours, name: `${service.engineHours} ${messages['engineHours']}` },
                    reminder: { id: service.engineHoursBefore, name: `${service.engineHoursBefore} ${messages['engineHours']}` },
                    pastDue: { id: service.engineHoursAfter, name: `${service.engineHoursAfter} ${messages['engineHours']}` }
                });
            } else {
                newIntervalTypesList.push({ id: "Hours", name: messages['engineHours'] });
            }

            setIntervalTypes(newIntervalTypesList);

            if (service.subscribers && service.subscribers.length) {
                newFormData.alerts = service.subscribers.map(subscriber => {
                    let options = [];

                    if (subscriber.alert) {
                        options.push({ id: "Reminder", name: messages['reminder'] });
                    }

                    if (subscriber.alertBefore) {
                        options.push({ id: "DueNow", name: messages['dueNow'] });
                    }

                    if (subscriber.alertAfter) {
                        options.push({ id: "PastDue", name: messages['pastDue'] });
                    }

                    return {
                        id: subscriber?.id,
                        contactId: subscriber?.contactId,
                        title: contacts?.filter(c => c?.id ==subscriber?.contactId)?.map(c => c?.title),
                        options: options
                    }
                });
            }

            if (service.files && service.files.length) {
                newFormData.attachments = service.files.map(file => file);
            }

            if (service.serviceItems && service.serviceItems.length) {
                setServiceItemSelected(service.serviceItems)
                setTimeout(() => {
                    let values = {}
                    let newOptions = optionsSelect
                    service.serviceItems.forEach((serv, index) => {
                        values[`parts-${index}`] = serv?.parts || '0'
                        values[`labor-${index}`] = serv?.labor || '0'
                        values[`subtotal-${index}`] = serv?.subtotal || '0'
                        newOptions = newOptions.filter((option) => option?.id != serv?.id);
                    });

                    newOptions && setOptionsSelect(OrderData(newOptions, 'name'));

                    updateFormRef.setValues(values)
                    getTotalCost(service.serviceItems);
                }, 100);
            }
        }
        setFormData({ ...formData, ...newFormData });
        updateFormRef && updateFormRef.setValues({ ...formData, ...newFormData });
    }

    const onDelete = (id) => {
        let newServiceItems = JSON.parse(JSON.stringify(serviceItemSelected));
        let newOptionsSelect = JSON.parse(JSON.stringify(optionsSelect));
        const oldOptionSelected = newServiceItems.find((service) => service.id == id);
        newServiceItems = newServiceItems.filter((service) => service.id != id);
        newOptionsSelect.push(oldOptionSelected);
        setOptionsSelect(OrderData(newOptionsSelect, 'name'));
        setServiceItemSelected(newServiceItems);

        newServiceItems.forEach((item, index) => {
            setTimeout(() => {
                formRef.setValues({
                    [`parts-${index}`]: item?.parts,
                    [`labor-${index}`]: item?.labor,
                    [`subtotal-${index}`]: item?.subtotal,
                })
            }, 200);
        });

        getTotalCost(newServiceItems);
    };

    const handleClose = useCallback(() => {
        if (!updateMaintenanceServiceResult && !loadingCreateAlertSubscriber) {
            setFormData({ intervalTypes: [], alerts: [], attachments: [] });
            setIntervalType(null);
            setInterval(null);
            setReminder(null);
            setPastDue(null);
            setErrors([]);
            dispatch(reset());
            if(user.isKph){
                setIntervalTypes(INTERVAL_TYPES.map((item) => {
                    if (item.id === "Miles"){
                        item.name = messages['kilometers'];
                    }
                    return item;
                }));
            } else {
                setIntervalTypes([...INTERVAL_TYPES]);
            }
        }
        dispatch(reset());
    })

    const renderItem = (item, key) => {
        let name = item?.name || ""

        if (name.length > 15) {
            name = name.slice(0, 15) + '...';
        }
        return (
            <Grid container item sm={12} key={key} spacing={0} alignItems="center">
                <Grid item sm={2} style={{ height: 80 }}>
                    <Grid container direction="column" alignItems="flex-start" justifyContent="center" className="contentLabelItems overflow-break-word">
                        <Grid item container sm={12}>
                            <Grid item sm={12}>
                                <label style={{
                                    color: '#000',
                                    fontSize: 12,
                                    fontWeight: 'bold',
                                    lineHeight: 1.5,
                                    letterSpacing: '.00938em',
                                    alignSelf: 'unset',
                                }}>
                                    {messages['completeMaintenanceService_item']}
                                </label>
                            </Grid>
                        </Grid>
                        <Grid item container className="labelContainer" alignItems="center" justifyContent="center" style={{ marginBottom: 4 }}>
                            <Grid item sm={12} style={{ width: 200 }}>
                                <label className="labelItemService table-span">{name}</label>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item container justifyContent="flex-end" alignItems="center" sm={10}>
                    <Grid item container sm={11} spacing={1}>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`parts-${key}`}
                                label={messages['completeMaintenanceService_parts']}
                                rules={[
                                    {
                                        min: 0,
                                        message: `${messages['min']}: 0`
                                    },
                                    {
                                        max: 999999,
                                        message: `${messages['max']}: 999999`
                                    }
                                ]}
                            >
                                <InputNumeric
                                    id={`parts-${key}`}
                                    type="number"
                                    onChange={(value) => {
                                        onChangeItem(key, 'parts', value);
                                        setTimeout(() => {
                                            let currentValues = parseFloat(value || 0) + parseFloat(item.labor || 0)
                                            updateFormRef.setValues({
                                                [`subtotal-${key}`]: currentValues
                                            })
                                        }, 200);
                                    }}
                                    placeholder={'$'}
                                    maxLength={9}
                                    decimalPlaces={2}
                                />
                            </Form.Item>
                        </Grid>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`labor-${key}`}
                                label={messages['completeMaintenanceService_labor']}
                                rules={[
                                    {
                                        min: 0,
                                        message: `${messages['min']}: 0`
                                    },
                                    {
                                        max: 999999,
                                        message: `${messages['max']}: 999999`
                                    }
                                ]}
                            >
                                <InputNumeric
                                    id={`labor-${key}`}
                                    type="number"
                                    onChange={(value) => {
                                        onChangeItem(key, 'labor', value);
                                        setTimeout(() => {
                                            let currentValues = parseFloat(item.parts || 0) + parseFloat(value || 0)
                                            updateFormRef.setValues({
                                                [`subtotal-${key}`]: currentValues
                                            })
                                        }, 200);
                                    }}
                                    placeholder={'$'}
                                    maxLength={9}
                                    decimalPlaces={2}
                                />
                            </Form.Item>
                        </Grid>
                        <Grid item sm={4}>
                            <Form.Item
                                name={`subtotal-${key}`}
                                label="SUBTOTAL"
                            >
                                <InputNumeric
                                    id={`subtotal-${key}`}
                                    type="currency"
                                    onChange={(value) => {
                                        onChangeItem(key, 'labor', value);
                                    }}
                                    placeholder={'$'}
                                    isDisabled
                                    decimalPlaces={2}
                                />
                            </Form.Item>
                        </Grid>
                    </Grid>
                    <Grid item container justifyContent="flex-end" sm={1}>
                        <Grid item sm={3}></Grid>
                        <Grid item sm={9}>
                            <div className="form-item">
                                <label className="input-normal-label"></label>
                                <IconButton
                                    aria-label="placeholder"
                                    className="icon-trash-item"
                                    onClick={() => onDelete(item.id)}
                                    icon="delete"
                                    style={{ padding: 5, fontSize: 20 }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };


    const onChangeItem = (key, name, value) => {
        setServiceItemsValidation(false)
        let newServiceItems = JSON.parse(JSON.stringify(serviceItemSelected));
        let newValue = value;
        if (newValue < 0) {
            newValue = 0;
        }
        if (newServiceItems[key]) {
            let temp = newServiceItems[key];
            temp[name] = +newValue === 0 ? newValue : parseFloat(newValue)
            temp['subtotal'] = parseFloat(temp.parts || 0) + parseFloat(temp.labor || 0);
            newServiceItems[key] = temp;
            setServiceItemSelected(newServiceItems);
            getTotalCost(newServiceItems);
        }
    };

    const reducer = (accumulator, currentValue) => accumulator + currentValue.subtotal;


    const getTotalCost = (newServiceItem) => {
        if (newServiceItem.length) {
            const total = newServiceItem.reduce(reducer, 0);
            setTimeout(() => {
                updateFormRef?.setValues({ totalCost: total.toFixed(2) })
            }, 100);
        } else {
            setTimeout(() => {
                updateFormRef?.setValues({ totalCost: 0 })
            }, 100);
        }
    };

    const getList = (start, end, increase, name) => {
        let list = [];
        let i = start;
        while (i < end) {
            list.push({
                id: i,
                name: `${i} ${name}`
            });
            let sum = increase;
            if (i >= 500 && i < 2000) {
                sum = 50;
            } else if (i >= 2000 && i < 5000) {
                sum = 100;
            } else if (i >= 5000 && i < 10000) {
                sum = 500;
            } else if (i >= 10000 && i < 25000) {
                sum = 1000;
            } else if (i >= 25000) {
                sum = 5000;
            }
            i += sum;
        }
        return list;
    }

    const milesList = getList(100, 120001, 100, user.isKph ? messages['kilometers'] : messages['miles']);
    const daysList = getList(1, 1001, 1, messages['days']);
    const hoursList = getList(10, 5001, 10, messages['hours']);

    const addIntervalType = () => {
        let { intervalTypes: intervalTypesForm } = formData;
        intervalTypesForm = intervalTypesForm || [];
        let newIntervalTypesForm = [...intervalTypesForm];
        if (intervalType?.id === 'Miles' && user.isKph) {
            newIntervalTypesForm.push({
                intervalType: { ...intervalType },
                interval: {... intervalNew, id: convertToMIRound(intervalNew.id)},
                reminder: {... reminderNew, id: convertToMIRound(reminderNew.id)},
                pastDue: {... pastDueNew, id: convertToMIRound(pastDueNew.id)},
            });
        } else {
            newIntervalTypesForm.push({
                intervalType: { ...intervalType },
                interval: intervalNew,
                reminder: reminderNew,
                pastDue: pastDueNew
            });
        }

        let newIntervalTypesList = intervalTypes.filter(it => {
            return it.id != intervalType.id;
        });

        setIntervalTypes(newIntervalTypesList);
        setFormData({ ...formData, intervalTypes: [...newIntervalTypesForm] });
        setIntervalType(null);
        setInterval(null);
        setReminder(null);
        setPastDue(null);
        setIntervalNew(null);
        setReminderNew(null);
        setPastDueNew(null);
        setErrors([]);
        updateFormRef && updateFormRef.setValues({ intervalType: null });
    }

    const updateMaintenanceServiceCallback = useCallback(() => {
        let newErrors = [];

        if (!formData.intervalTypes.length) {
            newErrors.push("intervalTypes");
        }

        if (!newErrors.length) {
            let data = {
                title: formData.title,
                recurrent: true,
                notes: formData.notes,
                estimatedCost: parseFloat(formData.estimatedCost),
                miles: 0,
                milesBefore: 0,
                milesAfter: 0,
                days: 0,
                daysBefore: 0,
                daysAfter: 0,
                engineHours: 0,
                engineHoursBefore: 0,
                engineHoursAfter: 0,
                fileIds: []
            }

            let alertsForUpdate = [];
            alertsForUpdate = formData.alerts && formData.alerts.map(alert => {
                let alrt = alert.options.find(alertType => alertType.name === messages['reminder']);
                let alertBefore = alert.options.find(alertType => alertType.name === messages['dueNow']);
                let alertAfter = alert.options.find(alertType => alertType.name === messages['pastDue']);
                return {
                    contactId: alert.contactId,
                    alert: alrt ? 1 : 0,
                    alertBefore: alertBefore ? 1 : 0,
                    alertAfter: alertAfter ? 1 : 0
                }
            });

            formData.intervalTypes.forEach(intervalType => {
                if (intervalType.intervalType.id === 'Miles') {
                    data.miles = intervalType.interval.id;
                    data.milesBefore = intervalType.reminder ? intervalType.reminder.id : 0;
                    data.milesAfter = intervalType.pastDue ? intervalType.pastDue.id : 0;
                } else if (intervalType.intervalType.name === messages['days']) {
                    data.days = intervalType.interval.id;
                    data.daysBefore = intervalType.reminder ? intervalType.reminder.id : 0;
                    data.daysAfter = intervalType.pastDue ? intervalType.pastDue.id : 0;
                } else if (intervalType.intervalType.name === messages['engineHours']) {
                    data.engineHours = intervalType.interval.id;
                    data.engineHoursBefore = intervalType.reminder ? intervalType.reminder.id : 0;
                    data.engineHoursAfter = intervalType.pastDue ? intervalType.pastDue.id : 0;
                }
            });

            if (formData.id) data.id = formData.id;

            if (formData.attachments && formData.attachments.length) {
                data.fileIds = formData.attachments.map(attachment => {
                    if (attachment?.id || attachment?.Id) {
                        return attachment.id || attachment.Id;
                    }
                })
            }

            data.subscribers = alertsForUpdate || []
            let itemsResult = []
            if (serviceItemSelected.length > 0) {
                serviceItemSelected.map((item) => {
                    const { __typename, ...resultItem } = item;
                    itemsResult.push({
                        id:resultItem?.id,
                        parts:resultItem?.parts || 0,
                        labor:resultItem?.labor || 0,
                        subtotal:resultItem?.subtotal || 0,
                        name:resultItem?.name
                    })
                })
                data.items = itemsResult;
            }
            dispatch(maintenanceMCSCreateEditMaintenanceService(data));
        }

        setErrors(newErrors);
    })

    const getIntervalLimits = (intervalType) => {
        let limits = { max: 0, min: 0 }

        switch (intervalType) {
            case "Miles":
                limits = { min: 200, max: 500000, label: user.isKph ? messages['kilometers'] : messages['miles'] }
                break;
            case "Hours":
                limits = { min: 10, max: 7000, label: messages['hours'] }
                break;
            case "Days":
                limits = { min: 2, max: 1900, label: messages['days'] }
                break;
            default:
                break;
        }
        return limits
    }

    const getReminderLimits = (intervalType, interval) => {
        let limits = { max: 0, min: 0 }
        if (interval?.id)
            switch (intervalType) {
                case "Miles":
                    limits = { min: 190, max: (_.toInteger(interval?.id) - 1) < 190 ? 200 : (_.toInteger(interval?.id) - 1), label: user.isKph ? messages['kilometers'] : messages['miles'] }
                    break;
                case "Hours":
                    limits = { min: 5, max: (_.toInteger(interval?.id) - 1) < 5 ? 10 : (_.toInteger(interval?.id) - 1), label: messages['hours'] }
                    break;
                case "Days":
                    limits = { min: 1, max: (_.toInteger(interval?.id) - 1) < 1 ? 2 : (_.toInteger(interval?.id) - 1), label: messages['days'] }
                    break;
                default:
                    break;
            }
        return limits
    }

    const getPastDueLimits = (intervalType, interval) => {
        let limits = { max: 0, min: 0 }
        if (interval?.id)
            switch (intervalType) {
                case "Miles":
                    limits = { min: _.toInteger(interval?.id) + 1, max: 1000000, label: user.isKph ? messages['kilometers'] : messages['miles'] }
                    break;
                case "Hours":
                    limits = { min: _.toInteger(interval?.id) + 1, max: 14000, label: messages['hours'] }
                    break;
                case "Days":
                    limits = { min: _.toInteger(interval?.id) + 1, max: 3800, label: messages['days'] }
                    break;
                default:
                    break;
            }
        return limits
    }

    const setDefaultValues = (intervalType, intervalValue, defaultValue) => {
        let defaultReminder = { id: 0, name: "" }
        let defaultPastDue = { id: 0, name: "" }

        if (intervalValue?.id)
            switch (intervalType.id) {
                case "Miles":
                    if (!defaultValue) {
                        defaultReminder = { id: (_.toInteger(intervalValue?.id) - 10) < 0 ? 0 : _.toInteger(intervalValue?.id) - 10, name: user.isKph ? messages['kilometers'] : messages['miles'] }
                        defaultPastDue = { id: _.toInteger(intervalValue?.id) + 10, name: user.isKph ? messages['kilometers'] : messages['miles'] }
                    } else {
                        defaultReminder = { id: 100000, name: user.isKph ? messages['kilometers'] : messages['miles'] }
                        defaultPastDue = { id: 300000, name: user.isKph ? messages['kilometers'] : messages['miles'] }
                    }
                    break;
                case "Hours":
                    if (!defaultValue) {
                        defaultReminder = { id: (_.toInteger(intervalValue?.id) - 5) < 0 ? 0 : _.toInteger(intervalValue?.id) - 5, name: messages['hours'] }
                        defaultPastDue = { id: _.toInteger(intervalValue?.id) + 5, name: messages['hours'] }
                    } else {
                        defaultReminder = { id: 2000, name: messages['hours'] }
                        defaultPastDue = { id: 5000, name: messages['hours'] }
                    }
                    break;
                case "Days":
                    if (!defaultValue) {
                        defaultReminder = { id: (_.toInteger(intervalValue?.id) - 1) < 0 ? 0 : _.toInteger(intervalValue?.id) - 1, name: messages['days'] }
                        defaultPastDue = { id: _.toInteger(intervalValue?.id) + 1, name: messages['days'] }
                    } else {
                        defaultReminder = { id: 450, name: messages['days'] }
                        defaultPastDue = { id: 1350, name: messages['days'] }
                    }
                    break;
                default:
                    break;
            }

        setReminderNew(defaultReminder);
        setPastDueNew(defaultPastDue);

        setTimeout(() => {
            intervalTypeFormRef.setValues({ interval_: parseFloat(intervalValue.id), reminder_: defaultReminder.id, pastDue_: defaultPastDue.id });
        }, 100);
    }

    const addNewOption = (name) => {
        if (name) {
            dispatch(maintenanceMCSCCreateMaintenanceServiceItem({ name }))
        }
    };

    const onChangeSelectedItems = (value) => {
        setServiceItemSelected((service) => {
            return [
                ...service,
                { ...value, parts: 0, labor: 0, subtotal: 0 },
            ]
        });
        setTimeout(() => {
            updateFormRef.setValues({
                [`parts-${serviceItemSelected?.length}`]: '0',
                [`labor-${serviceItemSelected?.length}`]: '0',
                [`subtotal-${serviceItemSelected?.length}`]: '0',
            })
        }, 100);
        const newOptions = optionsSelect.filter((option) => option?.id != value?.id);
        newOptions && setOptionsSelect(OrderData(newOptions, 'name'));
    };

    const addNewServiceItemToSelect = (serviceItem) => {
        let newServiceItems = JSON.parse(JSON.stringify(serviceItems))
        newServiceItems = [serviceItem, ...newServiceItems];
        setOptionsSelect(OrderData(newServiceItems, 'name'));
    }

    let title = formData.id ? `${messages['updateService_EditTitle']} "${formData.title}"` : messages['updateService_title'];

    return (
        <Modal
            title={title && title.length > 48 ? title.substring(0, 45) + '..."' : title}
            open={open}
            handleClose={handleClose}
            position="right"
            style={{ zIndex: 'auto' }}
            size="small"
            loading={loading || loadingCreateAlertSubscriber}
            footer={(
                <div style={{ display: 'flex', alignItems: "center", width: '100%' }}>
                    <Button
                        isDisabled={loading || loadingCreateAlertSubscriber}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        isDisabled={loading || loadingCreateAlertSubscriber}
                        onClick={() => {
                            updateFormRef?.submit();
                        }}
                        variant='primary'
                    >
                        {id ? messages['update'] : messages['service_title_add_button']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: 24 }}>
                <Form
                    ref={updateFormRef.ref}
                    loading={loading}
                    onValidSubmit={(values) => {
                        updateMaintenanceServiceCallback()
                    }}
                    onChangeValues={() => { }}
                >
                    <Form.Item
                        name="title"
                        label={messages['updateService_titleInputLabel']}
                        rules={[{ required: true, message: messages['required_field'] }]}
                    >
                        <Input
                            id="title"
                            type="text"
                            placeholder={messages['updateService_titleInputPlaceholder']}
                            onChange={(value) => setFormData({ ...formData, title: value })}
                            maxLength={50}
                        />
                    </Form.Item>
                    <Form.Item
                        name="estimatedCost"
                        label={messages['updateService_costInputLabel']}
                        rules={[
                            {
                                max: 1000000000,
                                message: `${messages['max']}: 1000000000`
                            }
                        ]}
                    >
                        <InputNumeric
                            id="estimatedCost"
                            type="currency"
                            placeholder={messages['updateService_costInputPlaceholder']}
                            maxLength={12}
                            onChange={(value) => {
                                value = value.replace(/[_-]/g, "");
                                setFormData({ ...formData, estimatedCost: parseFloat(value) });
                                setTimeout(() => {
                                    updateFormRef.setValues({ estimatedCost: value })
                                }, 50);
                            }}
                            decimalPlaces={2}
                        />
                    </Form.Item>
                    <Form.Item
                        name="intervalType"
                        label={messages['updateService_intervalTypeInputLabel']}
                        rules={[{ required: formData?.intervalTypes?.length ? false : true, message: messages['required_field'] }]}
                    >
                        <SelectInterval
                            id="intervalType"
                            textField="name"
                            valueField="id"
                            options={intervalTypes}
                            isClearable
                            onChange={(value) => {
                                if (value) {
                                    let newInterval = null;
                                    //TODO: Getting the unit mesure configured by the account in session
                                    //let unit = getUnitMesure(this.props.unitMesure);
                                    let unit = user.isKph ? messages['kilometers'] : messages['miles'];

                                    if (value.id === "Miles") {
                                        newInterval = { id: 200000, name: `200000 ${unit}` };
                                    } else if (value.id === "Hours") {
                                        newInterval = { id: 3500, name: `3500 ${messages['hours']}` };
                                    } else if (value.id === "Days") {
                                        newInterval = { id: 950, name: `950 ${messages['days']}` };
                                    }

                                    setInterval(newInterval);
                                    setIntervalNew(newInterval);
                                    setDefaultValues(value, newInterval, true);

                                } else {
                                    setInterval(null);
                                    setIntervalNew(null);
                                    setReminderNew(null);
                                    setPastDueNew(null);
                                }

                                //addIntervalTypeForm?.current?.reset();

                                setIntervalType(value);
                                setReminder(null);
                                setPastDue(null);
                                setErrors([]);
                            }}
                        />
                    </Form.Item>
                    <Form
                        ref={intervalTypeFormRef.ref}
                        onValidSubmit={() => addIntervalType()}
                        onChangeValues={() => { }}
                    >
                        {
                            intervalType
                            &&
                            <div>
                                <Grid
                                    container
                                    spacing={1}
                                    direction="row"
                                    justifyContent="flex-start"
                                    alignItems="flex-start"
                                >
                                    <Grid item xs={4}>
                                        <Form.Item
                                            name="interval_"
                                            label={messages['updateService_intervalInputLabel']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: messages['required_field'],
                                                },
                                                {
                                                    min: getIntervalLimits(intervalType.id).min,
                                                    message: `${messages['min']}: ${getIntervalLimits(intervalType.id).min} ${getIntervalLimits(intervalType.id).label}`,
                                                },
                                                {
                                                    max: getIntervalLimits(intervalType.id).max,
                                                    message: `${messages['max']}: ${getIntervalLimits(intervalType.id).max} ${getIntervalLimits(intervalType.id).label}`,
                                                }
                                            ]}
                                        >
                                            <InputNumeric
                                                id="interval_"
                                                type="number"
                                                onlyPositive
                                                placeholder={messages['updateService_intervalInputPlaceholder']}
                                                onChange={(value) => {
                                                    if (value) {
                                                        let intervl = { id: value, name: getIntervalLimits(intervalType.id).label }
                                                        setIntervalNew(intervl)
                                                        setDefaultValues(intervalType, intervl)
                                                    } else {
                                                        intervalTypeFormRef.resetValues()
                                                        setIntervalNew(null)
                                                        setReminderNew(null)
                                                        setPastDueNew(null)
                                                    }
                                                }}
                                            />
                                        </Form.Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Form.Item
                                            name="reminder_"
                                            label={messages['updateService_reminderInputLabel']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: messages['required_field'],
                                                },
                                                {
                                                    min: getReminderLimits(intervalType.id, intervalNew).min,
                                                    message: `${messages['min']}: ${getReminderLimits(intervalType.id, intervalNew).min} ${getReminderLimits(intervalType.id, intervalNew).label}`,
                                                },
                                                {
                                                    max: getReminderLimits(intervalType.id, intervalNew).max,
                                                    message: `${messages['max']}: ${getReminderLimits(intervalType.id, intervalNew).max} ${getReminderLimits(intervalType.id, intervalNew).label}`
                                                }
                                            ]}
                                        >
                                            <InputNumeric
                                                id="reminder_"
                                                type="number"
                                                onlyPositive
                                                placeholder={messages['updateService_reminderInputPlaceholder']}
                                                onChange={(value) => setReminderNew({ id: value, name: getIntervalLimits(intervalType.id).label })}
                                                isDisabled={!intervalNew}
                                            />
                                        </Form.Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Form.Item
                                            name="pastDue_"
                                            label={messages['updateService_pastDueInputLabel']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: messages['required_field'],
                                                },
                                                {
                                                    min: getPastDueLimits(intervalType.id, intervalNew).min,
                                                    message: `${messages['min']}: ${getPastDueLimits(intervalType.id, intervalNew).min} ${getPastDueLimits(intervalType.id, intervalNew).label}`
                                                },
                                                {
                                                    max: getPastDueLimits(intervalType.id, intervalNew).max,
                                                    message: `${messages['max']}: ${getPastDueLimits(intervalType.id, intervalNew).max} ${getPastDueLimits(intervalType.id, intervalNew).label}`
                                                }
                                            ]}
                                        >
                                            <InputNumeric
                                                id="pastDue_"
                                                type="number"
                                                onlyPositive
                                                placeholder={messages['updateService_pastDueInputPlaceholder']}
                                                onChange={(value) => setPastDueNew({ id: value, name: getIntervalLimits(intervalType.id).label })}
                                                isDisabled={!intervalNew}
                                            />
                                        </Form.Item>
                                    </Grid>
                                </Grid>

                                <div style={{ marginTop: 10 }}>
                                    <Button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            intervalTypeFormRef.submit();
                                        }}
                                        style={{ backgroundColor: 'black', width: '100%' }}
                                        variant="primary"
                                    >
                                        {`${messages['updateService_addNewIntervalType']} (${intervalType?.name})`}

                                    </Button>
                                </div>
                            </div>
                        }
                        {
                            formData.intervalTypes.length > 0
                            &&
                            <div style={{ marginTop: 5 }}>
                                {
                                    formData.intervalTypes.map((iType, index) => {

                                        let interval = (iType.interval ? iType.interval.id : '');
                                        let reminder = (iType.reminder ? iType.reminder.id : '');
                                        let pastDue = (iType.pastDue ? iType.pastDue.id : '');
                                        if (iType.intervalType.id === "Miles" && user.isKph){
                                            interval = convertToKPH(interval)
                                            reminder = convertToKPH(reminder)
                                            pastDue = convertToKPH(pastDue)
                                        }
                                        const labelKph = user.isKph ? messages['kilometers'] : messages["miles"];
                                        const labelHours = iType.intervalType.id === "Hours" ? messages["hours"] : messages["days"];
                                        let unitLabel = iType.intervalType.id === "Miles" ? labelKph : labelHours;
                                        let label = `${interval ? messages["due_every"] + " " + interval : ""} ${unitLabel}, ${(reminder ? messages['reminder_at'] + ' ' + reminder + " " + unitLabel + " , " : '')} ${(pastDue ? messages['pastDue_at'] + " " + pastDue + " " + unitLabel + ' ,' : '')} `;

                                        return (
                                            <Tooltip
                                                key={index}
                                                title={label}
                                            >
                                                <Pill
                                                    size="full"
                                                    textField="name"
                                                    item={{ label: label, color: '#005bf8' }}
                                                    icon="close"
                                                    onClickIcon={() => {
                                                        let { intervalTypes: formIntervalTypes } = formData;
                                                        let newFormIntervalTypes = [...formIntervalTypes];
                                                        newFormIntervalTypes = newFormIntervalTypes.filter(it => it.interval.name !== iType.interval.name);
                                                        setFormData({ ...formData, intervalTypes: newFormIntervalTypes });
                                                        let it = INTERVAL_TYPES.find(it => it.id === iType.intervalType.id);
                                                        let newIntervalTypes = [...intervalTypes];
                                                        
                                                        if (it.id === 'Miles' && user.isKph){
                                                            it = {... it, name: ` ${messages['kilometers']}`}
                                                        }
                                                        newIntervalTypes.push(it);

                                                        setIntervalTypes(newIntervalTypes);
                                                    }}
                                                    style={{ marginBottom: 5 }}
                                                />
                                            </Tooltip>
                                        )
                                    })
                                }
                            </div>
                        }
                        {
                            errors.includes("intervalTypes")
                            &&
                            <div style={{ marginBottom: 15 }}>
                                <small className="text-danger">{messages['updateService_intervalTypeError']}</small>
                            </div>
                        }
                    </Form>
                    <Form.Item
                        name="alerts"
                        label={messages['updateService_subscribers']}
                    >
                        <SelectMenu
                            id="alerts"
                            options={contacts || []}
                            loading={loadingContacts}
                            textField="title"
                            valueField="contactId"
                            placeholder={messages["scheduleVehicleService_alert_placeholder"]}
                            extraOptions={ALERT_TYPES || []}
                            extraOptionstextField="name"
                            extraOptionsvalueField="id"
                            extraOptionsRequiredMessage={messages["scheduleVehicleService_alert_error_message"]}
                            buttonLabel={messages["scheduleVehicleService_alert_button_label"]}
                            type="multi-checkbox"
                            onChange={(value) => {
                                setFormData({ ...formData, alerts: value })
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        name="attachments"
                        label={messages['updateService_attachmentsInputLabel']}
                    >
                        <FileUpload
                            id="attachments"
                            value={formData?.attachments}
                            placeholder={messages['updateService_attachmentsInputPlaceholder']}
                            types="image/*,.txt,.doc,.docx,.pdf,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            maxSize={4}
                            maxSizeMessage={`${messages['max']}: 4MB`}
                            helpText={messages['attachmentsFilesAllowed']}
                            uploadAttachment={(data) => { dispatch(uploadAttachment(data)) }}
                            uploadedAttachment={uploadedAttachment}
                            loadingUploadFile={loadingUploadFile}
                            onChange={(value) => setFormData({ ...formData, attachments: value })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="options"
                        label={messages['completeMaintenanceService_add_service_items']}
                    >
                        <div className="test-options">
                            <Select
                                addNewOption={addNewOption}
                                messageAdd={messages['completeMaintenanceService_add_new_service_item']}
                                onChange={(data) => {
                                    let payload = data
                                    if (payload?.label) {
                                        payload.name = payload?.label
                                    }
                                    if(data?.id)
                                        onChangeSelectedItems(payload)
                                }}
                                id="options"
                                options={optionsSelect}
                                textField="name"
                                valueField="id"
                                customIcon={() => <IconButton size="large" icon="add" style={{ padding: 5 }} />}
                                placeholder={messages['select']}
                                maxLength={40}
                                createOptions
                                isClearable
                                isSearchable
                            />
                        </div>

                    </Form.Item>
                    {serviceItemSelected &&
                        serviceItemSelected.map((item, key) => renderItem(item, key))}
                    {serviceItemsValidation && (
                        <Grid item sm={12}>
                            <small className="text-danger">{messages['completeMaintenanceService_error_items']}</small>
                        </Grid>
                    )}
                    <Form.Item
                        name="totalCost"
                        label={messages['completeMaintenanceService_total_cost']}
                    >
                        <InputNumeric
                            id="totalCost"
                            isDisabled={true}
                            placeholder="$0.00"
                            type="currency"
                        />
                    </Form.Item>
                    {
                        formData?.date && (
                            <>
                                <div className="checkbox-container">
                                    <Checkbox
                                        value={checkReschedule}
                                        onChange={changeReschedule}
                                        size="small"
                                        id="checkReschedule"
                                        label={messages['completeMaintenanceService_re_schedule_next_maintenance']}
                                    />
                                </div>
                                {
                                    checkReschedule &&
                                    <>
                                        {
                                            maintenanceServiceUnit?.service?.days ?
                                                <>
                                                    <Form.Item
                                                        name="nextDueDate"
                                                        label={messages['completeMaintenanceService_next_due_date']}
                                                        rules={[
                                                            {
                                                                required: maintenanceServiceUnit?.service?.days,
                                                                message: messages['required_field']
                                                            }
                                                        ]}
                                                    >
                                                        <DatePicker
                                                            id="nextDueDate"
                                                            showTimePicker
                                                            minDate={new Date(formData?.date)}
                                                            calendarPosition="bottom-end"
                                                            format={GetFormatForMoment(user.dateformat)}
                                                            onChange={(value) => setFormData({ ...formData, nextDueDate: value })}
                                                            placeholder={messages['completeMaintenanceService_select_date']}
                                                        />
                                                    </Form.Item>
                                                </>
                                                : <></>
                                        }
                                        {
                                            maintenanceServiceUnit?.service?.miles ?
                                                <Form.Item
                                                    name="nextOdometer"
                                                    label={messages['completeMaintenanceService_next_odometer']}
                                                    rules={[
                                                        {
                                                            required: maintenanceServiceUnit?.service?.miles,
                                                            message: messages['required_field']
                                                        },
                                                        {
                                                            min: parseFloat(formData.engineOdometer || 1),
                                                            message: `${messages['completeMaintenanceService_error_next_odometer']} ${parseFloat(formData.engineOdometer || 1)}`
                                                        }
                                                    ]}
                                                >
                                                    <InputNumeric
                                                        id="nextOdometer"
                                                        type="number"
                                                        placeholder=""
                                                        maxLength={15}
                                                        onChange={(value) => setFormData({ ...formData, nextOdometer: parseInt(value) })}
                                                        onlyPositive
                                                    />
                                                </Form.Item>
                                                : <></>
                                        }
                                        {
                                            maintenanceServiceUnit?.service?.engineHours ?
                                                <Form.Item
                                                    name="nextEngineHours"
                                                    label={messages['completeMaintenanceService_next_engine_hours']}
                                                    rules={[
                                                        {
                                                            required: maintenanceServiceUnit?.service?.engineHours,
                                                            message: messages['required_field']
                                                        },
                                                        {
                                                            min: parseFloat(formData.engineHours || 1),
                                                            message: `${messages['completeMaintenanceService_error_next_engine_hours']} ${parseFloat(formData.engineHours || 1)}`
                                                        }
                                                    ]}
                                                >
                                                    <InputNumeric
                                                        id="nextEngineHours"
                                                        type="number"
                                                        placeholder="$"
                                                        maxLength={8}
                                                        onChange={(value) => setFormData({ ...formData, nextEngineHours: parseInt(value) })}
                                                        onlyPositive
                                                    />
                                                </Form.Item>
                                                : <></>
                                        }
                                    </>
                                }
                            </>
                        )
                    }
                    <Form.Item
                        name="notes"
                        label={messages['updateService_notesInputLabel']}
                    >
                        <TextArea
                            id="notes"
                            placeholder={messages['updateService_notesInputPlaceholder']}
                            type="textarea"
                            maxLength={2000}
                            value={formData.notes || ''}
                            onChange={(value) => setFormData({ ...formData, notes: value })}
                        />
                    </Form.Item>
                </Form>
            </div>
            <NotificationContainer />
        </Modal>
    )
}


export default CreateEditMaintenanceService
